module.exports = __webpack_public_path__ + "img/delivery-background.735d1491.png";